export default [{
  path: '/sick-leaves',
  name: 'sickLeave',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/sickLeave/index')
}]
